import { type CohortBuilderDefinitionLegacy } from '@verantos-dev/types-cohorts';

import { validateCohortDefinitionForProcessing } from './validateCohortDefinitionForProcessing';
import { validateCohortDefinitionForSave } from './validateCohortDefinitionForSave';
import { type CohortBuilderWorkflow } from '../types';

export const getNextCohortBuilderWorkflowForViewedItem = (
  id: string,
  hasViewedItem: boolean,
  currentCohortBuilderWorkflow: CohortBuilderWorkflow | undefined,
  nextActiveCohortBuilderState: CohortBuilderDefinitionLegacy | undefined
): CohortBuilderWorkflow => {
  return {
    ...currentCohortBuilderWorkflow,
    // actionModal: currentCohortBuilderWorkflow?.actionModal ?? undefined,
    cohortBuilderItemIdsToNamesMap:
      currentCohortBuilderWorkflow?.cohortBuilderItemIdsToNamesMap ?? {},
    cohortBuilderItemNamesToIdsMap:
      currentCohortBuilderWorkflow?.cohortBuilderItemNamesToIdsMap ?? {},
    inUseCohortBuilderItemsMap: currentCohortBuilderWorkflow?.inUseCohortBuilderItemsMap ?? {},
    hasUnsavedChanged: nextActiveCohortBuilderState
      ? validateCohortDefinitionForSave(nextActiveCohortBuilderState)
      : false,
    isProcessEnabled: nextActiveCohortBuilderState
      ? validateCohortDefinitionForProcessing(nextActiveCohortBuilderState)
      : false,
    modal: currentCohortBuilderWorkflow?.modal ?? undefined,
    // activeStep: currentCohortBuilderWorkflow?.activeStep ?? DEFAULT_COHORT_BUILDER_STEP,
    viewedCohortBuilderItems: {
      ...currentCohortBuilderWorkflow?.viewedCohortBuilderItems,
      [id]: hasViewedItem,
    },
  };
};
